import { Site } from '@debbie/common/dist/index.js';
import { usePausedCases } from '@debbie/cortex/dist/home/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { useTeams } from '@debbie/cortex/dist/teams/index.js';
import { useUpdateTypes, useUpdateTypesMap, } from '@debbie/cortex/dist/update-types/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import HelpCircle from './Icons/HelpCircle.js';
import { Info, Pause, UserX } from './Icons/index.js';
import { Input, RadioSelect, UserPreview } from './index.js';
import Panel from './Panel.js';
import PlaceholderLoader from './PlaceholderLoader.js';
import TeamPreview from './TeamPreview.js';
const iconStyle = {
    margin: '0.2em 0.2em -0.2em 0.3em',
    width: '1.1em',
    height: '1.1em',
};
const orderResponsibles = (a, me) => {
    if (a.responsibleType === 'unassigned') {
        return 3;
    }
    if (a.responsibleReferenceId === me.id) {
        return 1;
    }
    return 2;
};
const TodoPanel = (props) => {
    const updateTypesLoadable = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable)
        ? updateTypesLoadable.data
        : null;
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const lang = useSelector((s) => s.lang);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const usersLoadable = useUsers();
    const allUsers = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const creditorId = useSelector((s) => s.selectedCreditor);
    const site = useSelector((s) => s.site);
    const caseFilter = useCaseFilter();
    const pausedCasesLoadable = usePausedCases(caseFilter, (Site.Client === site && creditorId) || undefined);
    const pausedCases = h.hasData(pausedCasesLoadable)
        ? pausedCasesLoadable.data
        : null;
    const [responsibleRole, setResponsibleRole] = useState(Site.Client === site ? 'client' : 'caseworker');
    const [redirecting, setRedirecting] = useState(null);
    const [q, setQ] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const [itemsNotGrouped, setItemsNotGrouped] = useState(null);
    const [items, setItems] = useState(null);
    const [responsibles, setResponsibles] = useState([]);
    const [selectedResponsibles, setSelectedResponsibles] = useState({});
    const teamsLoadable = useTeams(!!(responsibles.length && site === Site.Caseworker));
    const teams = h.hasData(teamsLoadable) ? teamsLoadable.data : null;
    useEffect(() => {
        if (pausedCases && updateTypes) {
            setItemsNotGrouped(pausedCases.map((pausedCase) => {
                const updateType = updateTypesMap[pausedCase?.updateTypeId];
                return {
                    responsibleType: pausedCase.responsibleType,
                    responsibleReferenceId: pausedCase.responsibleReferenceId,
                    updateTypeId: pausedCase.updateTypeId,
                    count: pausedCase.count,
                    updateType,
                };
            }));
        }
    }, [pausedCases, updateTypes]);
    useEffect(() => {
        if (pausedCases) {
            const _responsibles = Object.values(pausedCases.reduce((acc, pause) => {
                if (pause.responsibleType) {
                    acc[pause.responsibleType + pause.responsibleReferenceId] = {
                        responsibleType: pause.responsibleType,
                        responsibleReferenceId: pause.responsibleReferenceId,
                    };
                }
                else {
                    acc['unassigned'] = {
                        responsibleType: 'unassigned',
                        responsibleReferenceId: null,
                    };
                }
                return acc;
            }, {}));
            setResponsibles(_responsibles);
        }
    }, [pausedCases]);
    useEffect(() => {
        if (responsibles.length &&
            me &&
            teams &&
            Object.keys(selectedResponsibles).length === 0) {
            setSelectedResponsibles({
                ...responsibles.reduce((acc, responsible) => {
                    if (responsible.responsibleType === 'user' &&
                        me.id === responsible.responsibleReferenceId) {
                        acc[responsible.responsibleReferenceId] = true;
                    }
                    if (responsible.responsibleReferenceId &&
                        responsible.responsibleType === 'team') {
                        const team = teams.find((team) => team.id === responsible.responsibleReferenceId);
                        if (team &&
                            team.users.map((user) => user.userId).includes(me.id)) {
                            acc[responsible.responsibleReferenceId] = true;
                        }
                    }
                    return acc;
                }, {}),
                unassigned: true,
            });
        }
    }, [responsibles, me, teams]);
    useEffect(() => {
        if (itemsNotGrouped) {
            setItems(itemsNotGrouped.filter((item) => {
                const isSelectedResponsibleRole = item.updateType?.responsiblePermissionLevel == responsibleRole;
                const itemMatchesQuery = `${item.updateType?.label}${lang.updateTypes[item.updateTypeId]}${
                // @ts-ignore
                lang.updateTypesClient[item.updateTypeId]}`
                    .toLocaleLowerCase()
                    .indexOf(q.toLocaleLowerCase()) !== -1;
                const itemSelected = selectedResponsibles[item.responsibleType && item.responsibleReferenceId
                    ? item.responsibleReferenceId
                    : 'unassigned'] ||
                    Object.values(selectedResponsibles).filter((_) => _).length === 0;
                const itemNotForCaseworkers = !['caseworker', 'admin', 'super-admin'].includes(item.updateType?.responsiblePermissionLevel);
                return (isSelectedResponsibleRole &&
                    itemMatchesQuery &&
                    (itemSelected || itemNotForCaseworkers));
            }));
        }
    }, [itemsNotGrouped, responsibleRole, selectedResponsibles, q]);
    const sortedItems = items &&
        Object.values(items.reduce((acc, item) => {
            const key = item.updateTypeId;
            if (!acc[key]) {
                acc[key] = {
                    count: 0,
                    updateTypeId: item.updateTypeId,
                    updateType: item.updateType,
                };
            }
            acc[key].count = acc[key].count + item.count;
            return acc;
        }, {})).sort((a, b) => b.count - a.count);
    const setIndex = (selectedIndex) => {
        if (sortedItems) {
            setSelectedIndex(selectedIndex < 0
                ? 0
                : selectedIndex >= sortedItems.length
                    ? sortedItems.length - 1
                    : selectedIndex);
        }
    };
    const genQueryParams = () => {
        const _selectedResponsibles = responsibles?.filter((responsible) => responsible.responsibleReferenceId &&
            selectedResponsibles[responsible.responsibleReferenceId]);
        const _responsibles = _selectedResponsibles?.filter((responsible) => responsible.responsibleReferenceId &&
            selectedResponsibles[responsible.responsibleReferenceId] &&
            responsible.responsibleType !== 'unassigned');
        const includeUnassigned = !!selectedResponsibles['unassigned'];
        return _responsibles.length || includeUnassigned
            ? `?responsibles=${JSON.stringify({
                responsibles: _responsibles.length
                    ? _responsibles.map((r) => ({
                        type: r.responsibleType,
                        referenceId: r.responsibleReferenceId,
                    }))
                    : undefined,
                includeUnassigned: includeUnassigned ? true : undefined,
            })}`
            : '';
    };
    const goToUpdateType = async (updateTypeId) => {
        if (redirecting !== updateTypeId) {
            setRedirecting(updateTypeId);
            setRedirecting(null);
            c.redirect.redirect(`/todo-queue/${updateTypeId}${genQueryParams()}`);
        }
    };
    const caseworkerTodos = itemsNotGrouped?.filter((item) => item.updateType?.responsiblePermissionLevel === 'caseworker');
    const clientTodos = itemsNotGrouped?.filter((item) => item.updateType?.responsiblePermissionLevel === 'client');
    const noResponsibleTodos = itemsNotGrouped?.filter((item) => !['client', 'caseworker'].includes(item.updateType?.responsiblePermissionLevel || ''));
    return (React.createElement(StyledTodoPanel, { placeholder: lang.home.todos, maxHeight: "550px", header: React.createElement(React.Fragment, null,
            lang.home.todos,
            React.createElement("small", null, itemsNotGrouped
                ? itemsNotGrouped.reduce((acc, item) => item.count + acc, 0)
                : null)) },
        React.createElement(MultipleSelectors, { onClick: () => setSelectedIndex(0) },
            caseworkerTodos && !!caseworkerTodos.length && (React.createElement(MultipleSelector, { onClick: () => setResponsibleRole('caseworker') },
                React.createElement(RadioSelect, { label: `${lang.home.caseworkerTodo} (${caseworkerTodos.reduce((acc, item) => item.count + acc, 0)})`, active: 'caseworker' === responsibleRole }))),
            clientTodos && !!clientTodos.length && (React.createElement(MultipleSelector, { onClick: () => setResponsibleRole('client') },
                React.createElement(RadioSelect, { label: `${lang.home.clientTodo} (${clientTodos.reduce((acc, item) => item.count + acc, 0)})`, active: 'client' === responsibleRole }))),
            noResponsibleTodos && !!noResponsibleTodos.length && (React.createElement(MultipleSelector, { onClick: () => setResponsibleRole(null) },
                React.createElement(RadioSelect, { label: `${lang.home.noResponsibleTodo} (${noResponsibleTodos.reduce((acc, item) => item.count + acc, 0)})`, active: null === responsibleRole })))),
        React.createElement(Input, { placeholder: lang.todoPanel.searchTodos, autofocus: true, value: q, onChange: (e) => {
                setQ(e.target.value);
                setSelectedIndex(0);
            }, onFocus: () => setIsActive(true), onBlur: () => setIsActive(false), onKeyDown: (e) => {
                switch (e.keyCode) {
                    case 13: {
                        const item = sortedItems && sortedItems[selectedIndex];
                        if (item) {
                            goToUpdateType(item?.updateTypeId);
                        }
                        return;
                    }
                    case 38: {
                        setIndex(selectedIndex - 1);
                        return;
                    }
                    case 40: {
                        setIndex(selectedIndex + 1);
                        return;
                    }
                }
            } }),
        responsibleRole === 'caseworker' &&
            !(responsibles.length === 1 &&
                responsibles[0].responsibleType === 'unassigned') &&
            !!responsibles.length &&
            me &&
            teams && (React.createElement("div", { style: { marginBottom: '10px' } }, responsibles
            .sort((rA, rB) => orderResponsibles(rA, me) - orderResponsibles(rB, me))
            .map((responsible, key) => {
            switch (responsible.responsibleType) {
                case 'team': {
                    const team = (teams || []).find((t) => t.id === responsible.responsibleReferenceId);
                    if (!team) {
                        return null;
                    }
                    return (React.createElement(TeamPreview, { key: team.id, style: {
                            cursor: 'pointer',
                            marginRight: '10px',
                            marginBottom: '7px',
                        }, team: team, active: selectedResponsibles[team.id], onClick: () => setSelectedResponsibles({
                            ...selectedResponsibles,
                            [team.id]: !selectedResponsibles[team.id],
                        }) }));
                }
                case 'user': {
                    const user = (allUsers || []).find((t) => t.id === responsible.responsibleReferenceId);
                    if (!user) {
                        return null;
                    }
                    return (React.createElement(UserPreview, { key: user.id, style: {
                            cursor: 'pointer',
                            marginRight: '10px',
                            marginBottom: '7px',
                        }, user: user, active: selectedResponsibles[user.id], onClick: () => setSelectedResponsibles({
                            ...selectedResponsibles,
                            [user.id]: !selectedResponsibles[user.id],
                        }) }));
                }
                case 'unassigned':
                    return (React.createElement(Unassigned, { key: key, style: {
                            cursor: 'pointer',
                            marginRight: '10px',
                            marginBottom: '7px',
                        }, active: selectedResponsibles['unassigned'], onClick: () => setSelectedResponsibles({
                            ...selectedResponsibles,
                            unassigned: !selectedResponsibles['unassigned'],
                        }) }));
                default:
                    return null;
            }
        }))),
        sortedItems &&
            sortedItems.map((item, i) => (React.createElement(ListItem, { active: i === selectedIndex && isActive, key: item.updateTypeId, onClick: () => goToUpdateType(item.updateTypeId) },
                React.createElement("div", null,
                    React.createElement("h3", null,
                        item.updateType?.pausing ? (React.createElement(Pause, { style: iconStyle })) : (React.createElement(Info, { style: iconStyle })),
                        ' ',
                        (site === Site.Client
                            ? // @ts-ignore
                                lang.updateTypesClient[item.updateTypeId]
                            : lang.updateTypes[item.updateTypeId]) ||
                            item.updateType?.label,
                        redirecting === item.updateTypeId && (React.createElement(PlaceholderLoader, { width: "70px", height: "35px", style: {
                                margin: '-16px 0 -16px 13px',
                            } })),
                        ' ',
                        item.updateType?.knowledgeBaseUrls[lang.is.currently] && (React.createElement(Help, { onClick: (e) => {
                                e.preventDefault();
                                if (item.updateType?.knowledgeBaseUrls[lang.is.currently]) {
                                    window.open(item.updateType?.knowledgeBaseUrls[lang.is.currently], '_blank');
                                }
                            } },
                            React.createElement(HelpCircle, null)))),
                    React.createElement("small", { style: {
                            position: 'absolute',
                            top: '5px',
                            right: '0',
                        } }, item.count))))),
        sortedItems && sortedItems.length == 0 && (React.createElement(H2, null, lang.home.todoPlaceholder)),
        !items && React.createElement(PlaceholderLoader, null)));
};
export default TodoPanel;
const Help = styled.div `
  font-size: 1.2em;
  vertical-align: text-bottom;
  margin: 0 60px -10px 10px;
  float: right;
  color: ${THEME.COLOR_ACCENT};
`;
const ListItem = styled.div `
  position: relative;
  border-bottom: 1px solid lightgrey;
  border-left: ${(props) => props.active ? `3px solid ${THEME.COLOR_ACCENT}` : 'none'};
  transition: all 0.2s;
  cursor: pointer;

  & > div,
  & > a > div {
    padding: ${(props) => (props.active ? '5px 5px' : '5px 0')};
  }

  & > h3 > small {
    float: right;

    svg {
      transform: translateY(2px);
      margin-left: 8px;
      font-size: 1.2em;
    }
  }

  h3 {
    margin: 0px 0 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9em;
  }

  p {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.7em;
  }

  &:last-child {
    border-bottom: none;
  }
`;
const H2 = styled.h2 `
  text-align: center;
  margin: 2em 0;
  opacity: 0.5;
`;
const MultipleSelectors = styled.div `
  padding: 0 0 15px 0;
`;
const MultipleSelector = styled.div `
  display: inline-block;
`;
const StyledTodoPanel = styled(Panel) `
  overflow-x: visible;
  position: relative;

  .header small {
    float: right;

    svg {
      transform: translateY(2px);
      margin-left: 8px;
      font-size: 1.2em;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  code {
    font-size: 0.6em;
    background: lightgrey;
    border-radius: 3px;
    padding: 3px 7px;
    margin-right: 15px;
    cursor: pointer;

    svg {
      margin: -4px;
      height: 15px;
      width: 23px;
    }
  }

  .body {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    max-height: ${(props) => (props.maxHeight ? props.maxHeight : '400px')};

    @media ${THEME.MEDIA_QUERY_MOBILE} {
      max-height: none;
    }
  }
`;
const Unassigned = (props) => {
    const { style, onClick, active } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(UserPreviewStyled, { style: style, onClick: onClick, active: active, "data-tooltip-id": 'tooltip-default', "data-tooltip-content": lang.home.unassigned },
        React.createElement(UserX, { style: {
                fontSize: '1.4em',
                margin: '0.2em 0 -0.2em',
            } })));
};
const UserPreviewStyled = styled.div `
  width: 27px;
  height: 27px;
  display: inline-block;
  text-align: center;
  border-radius: 100%;
  line-height: 27px;
  color: ${THEME.COLOR_SECONDARY};
  font-size: 11px;
  margin-right: 5px;
  background-color: grey;
  position: relative;

  ${(props) => props.active
    ? `
      &::before {
        content: ' ';
        border: 2px solid ${THEME.COLOR_ACCENT};
        width: 35px;
        height: 35px;
        border-radius: 100%;
        display: inline-block;
        position: absolute;
        left: -4px;
        top: -4px;
      }
    `
    : ''}
`;
//# sourceMappingURL=PausedCasesPanel.js.map